<script setup lang="ts">
import { usePaxStore } from '@apps/main/new-desktop/core/stores/pax/paxStore';
import { useMapStore } from '@apps/main/new-desktop/core/stores/mapStore/mapStore';

import { useTripSummaryStore } from '../../stores/tripSummaryStore';
import TripOverviewMap from '../TripOverviewMap.vue';
import { useTripOverviewPanelsStore } from '../../stores';

import TripPriceSummaryFooter from './TripPriceSummaryFooter.vue';

const tripSummaryStore = useTripSummaryStore();
const paxStore = usePaxStore();
const mapStore = useMapStore();
const tripOverviewPanelsStore = useTripOverviewPanelsStore();
</script>

<template>
  <div class="trip-summary-desktop">
    <TripOverviewMap
      v-if="!mapStore.shouldShowFullScreenMap"
      :should-have-border-radius="true"
      class="map"
      @zoom="mapStore.openFullScreenDynamicTripMap()"
    />

    <TripPriceSummaryFooter
      :paxes="paxStore.getPaxesButtonSimpleText"
      :travel-dates="tripSummaryStore.travelDateRange"
      :total-price-with-addons="tripSummaryStore.tripTotalPrice"
      :should-show-share-button="true"
      @total-price-clicked="tripOverviewPanelsStore.openTripPriceSummaryPanel"
    />
  </div>
</template>

<style scoped lang="scss">
.trip-summary-desktop {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .map {
    height: 100%;
    padding-bottom: var(--spacing-24);
  }
}
</style>
